import ApiExecute from ".";

const view = async () => {
  return await ApiExecute("zone");
};

const store = async (data) => {
  return await ApiExecute("zone", {
    method: "POST",
    data,
  });
};

const show = async (id) => {
  return await ApiExecute(`zone/${id}`);
};

const update = async (id, data) => {
  data._method = "PUT";
  return await ApiExecute(`zone/${id}`, {
    method: "POST",
    data,
  });
};

const destory = async (id) => {
  return await ApiExecute(`zone/${id}`, {
    method: "POST",
    data: {
      _method: "DELETE",
    },
  });
};

const zoneServices = {
  view,
  store,
  show,
  update,
  destory,
};

export default zoneServices;
